import * as THREE from 'three'
import type { ProceduralMaterialId } from '../../chunk-schema/src/index.ts'

const runtimeColours = [
  ['terrain-grass', '#9fb584'],
  ['asphalt', '#626965'],
  ['concrete', '#9a9a8e'],
  ['bridge-structure', '#666b68'],
  ['tunnel-interior', '#252b29'],
] as const satisfies readonly (readonly [ProceduralMaterialId, string])[]

/** Materials for terrain, road splines and their gameplay-critical structures. */
export function createRuntimeMaterials() {
  const materials = new Map<ProceduralMaterialId, THREE.MeshStandardMaterial>()
  for (const [id, colour] of runtimeColours) {
    materials.set(id, new THREE.MeshStandardMaterial({
      color: colour,
      roughness: 0.98,
      metalness: 0,
      flatShading: true,
      side: THREE.FrontSide,
    }))
  }
  return materials
}
